import {useNavigate} from 'react-router-dom';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import LoadingScreen from '../common/LoadingScreen';
import {useUpdatePatientMutation} from '../../redux/services/patientApi';

const handleLinkPatient = ({put, patientId, providerId, afterSubmit}) => async e => {
  const request = await put({id: patientId, body: {provider_id: providerId}});
  if (request.data && afterSubmit) {
    console.log('Linked to patient successfully', request);
    afterSubmit();
  }
};

const LinkToPatientScreen = ({patientId, providerId, afterSubmit}) => {
  const navigate = useNavigate();
  const [put, request] = useUpdatePatientMutation();
  const onSubmit = handleLinkPatient({
    put, 
    patientId, 
    providerId, 
    afterSubmit,
  });
  const onExit = () => navigate('/providers/patients')
  return (
    <Container maxWidth='xs'>
      <Paper>
        <Stack spacing={2} padding={3} justifyContent='center'>
          <Typography variant='h2' align='center'>
            You are not linked to this patient.
          </Typography>
          <Box>
            <Typography variant='body1' align='left'>
              Maintaining patient confidentiality is vital. By proceeding, you confirm that your access to this information is clinically necessary and aligns with our privacy policies. 
              <br/><br/>
              Thank you for helping us keep our patient data secure.
            </Typography>
          </Box>
          <Button variant='contained' onClick={onSubmit} disabled={request.isLoading}>
            I Agree
          </Button>
          <Button variant='outlined' onClick={onExit}>
            Exit
          </Button>
        </Stack>
      </Paper>
    </Container>
  );
};

export default LinkToPatientScreen;